import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const ArchiveStats = () => {
    const [data, setData] = useState([]);
    const [colors, setColors] = useState([]);
    const [isMobile, setIsMobile] = useState(() => (
        typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    ));

    const generateRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await axios.get('/api/stats/department');
                
                const formattedData = res.data.map(item => ({
                    name: item.department || 'Unknown',
                    value: parseInt(item.total)
                }));
                setData(formattedData);
                
                // Generate random colors for each department
                const randomColors = formattedData.map(() => generateRandomColor());
                setColors(randomColors);
            } catch (err) {
                console.error("Error fetching stats:", err);
            }
        };
        fetchStats();
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const mobileLegend = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px' }}>
            {data.map((entry, index) => (
                <div
                    key={entry.name}
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.9rem', color: '#555' }}
                >
                    <span
                        style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '999px',
                            background: colors[index]
                        }}
                    />
                    <span>{entry.name} ({entry.value})</span>
                </div>
            ))}
        </div>
    );

    return (
        <div className="card">
            <h3 className="title" style={{ marginBottom: '12px' }}>Archive Breakdown by Department</h3>
            <div style={{ width: '100%' }}>
                {/* Check if data exists before rendering chart */}
                {data.length > 0 ? (
                    <>
                        <div style={{ height: isMobile ? '280px' : '380px', width: '100%' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={data}
                                        cx={isMobile ? '50%' : '45%'}
                                        cy="50%"
                                        labelLine={false}
                                        outerRadius={isMobile ? 90 : 110}
                                        fill="#8884d8"
                                        dataKey="value"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={colors[index]} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    {!isMobile && <Legend verticalAlign="middle" align="right" layout="vertical" />}
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                        {isMobile && mobileLegend}
                    </>
                ) : (
                    <div className="muted" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '280px' }}>
                        No data available for chart
                    </div>
                )}
            </div>
        </div>
    );
};

export default ArchiveStats;

